import { ENVD_DOCUMENT } from "constants/actionTypes";

import { serializeEnvdDocument } from "lib/serializers/envd";

import {
  offlineActionCreator,
  offlineSubActionCreator,
  urlCheckAndAddIdAndAction,
} from "./lib";
import queryString from "query-string";

const urlCreator = ({ id, action, changesSince, livestockSaleId } = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/envd-documents/", id, action),
    query: {
      changesSince,
      livestock_sale_id: livestockSaleId,
    },
  });

export const EnvdDocumentAction = offlineActionCreator(
  ENVD_DOCUMENT,
  serializeEnvdDocument,
  urlCreator,
  true,
);

EnvdDocumentAction.refresh = (options = {}) => {
  const optionsWithParams = { action: "refresh", ...options };
  return {
    type: ENVD_DOCUMENT.REFRESH.REQUEST,
    meta: {
      offline: {
        effect: {
          url: urlCreator(optionsWithParams),
          method: "PATCH",
        },
        commit: {
          type: ENVD_DOCUMENT.REFRESH.SUCCESS,
        },
        rollback: {
          type: ENVD_DOCUMENT.REFRESH.FAILURE,
        },
      },
    },
  };
};

EnvdDocumentAction.createConsignmentAttachments = offlineSubActionCreator(
  ENVD_DOCUMENT.CREATE_CONSIGNMENT_ATTACHMENT,
  ({ id, consignmentId }) =>
    `${urlCreator({ id, action: "create-consignment-attachments" })}${consignmentId}/`,
);
